import {Component, Input, OnInit} from '@angular/core';
import {QRCode} from "../../../../models/QRCode";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ApiService} from "../../../../services/api.service";
import {NzModalRef} from "ng-zorro-antd/modal";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-qrcode-form',
  templateUrl: './qrcode-form.component.html',
  styleUrls: ['./qrcode-form.component.scss']
})
export class QrcodeFormComponent implements OnInit {

  @Input() type!: 'event' | 'campaign';
  @Input() typeID!: string | undefined;
  @Input() edit: boolean = false;
  @Input() code: QRCode | undefined;

  submitting: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  error: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  codeForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private api:ApiService,
    private modal: NzModalRef
  ) {
    this.codeForm = this.fb.group({
      loc_available: [false],
      loc: [],
      link_only: [false]
    });
  }

  ngOnInit(): void {
    if(this.code){
      for(const key of Object.keys(this.code)){
        if(this.codeForm.get(key)){
          this.codeForm.get(key)?.setValue(this.code[key]);
        }
      }
    }
  }

  get link_only(){
    return this.codeForm.get('link_only')?.value;
  }

  set link_only(data: boolean){
    this.codeForm.get('link_only')?.setValue(data);
  }

  get loc_available(){
    return this.codeForm.get('loc_available')?.value;
  }

  set loc_available(data: boolean){
    this.codeForm.get('loc_available')?.setValue(data);
  }

  destroyModal(): void {
    this.modal.destroy();
  }

  submitForm(): void {
    console.log(this.codeForm.value)
    this.submitting.next(true);
    let submitUrl = 'core/'+this.type+'s/' + this.typeID + '/codes';
    if(this.code){submitUrl += '/' + (this.code as |QRCode).id;}
    const action = this.code ? this.api.apiPatch(submitUrl, this.codeForm.value) : this.api.apiPost(submitUrl, this.codeForm.value);
    action.then((CodeResult)=> {
      this.submitting.next(false);
      this.modal.destroy(CodeResult);
    }).catch((CodeError) => {
      console.log(CodeError);
      this.submitting.next(false);
      this.error.next(true);
    })

  }

}
